import React, {useState} from 'react';
// @ts-ignore
import {ArrowLeft} from '@phosphor-icons/react';
import NewCampaign from './NewCampaign';
import EditCampaign from './EditCampaign';

// Routes between the two real Campaigns surfaces:
//   index 0 -> list view (NewCampaign)
//   index 1 -> edit view (EditCampaign)
// The previous tab UI ("Campaigns" / "Manage Campaign") was misleading because the second
// tab is meaningless without a selected campaign. We replace it with a clean back-nav that
// only appears in edit mode; the list view exposes its own filter chrome.
const CampaignHorizontalSubMenuComponent = ({index}) => {
	const [activeIndex, setActiveIndex] = useState(index);
	const [currentCampaign, setcurrentCampaign] = useState(null);

	return (
		<div className="w-full">
			{activeIndex === 1 && (
				<div className="max-w-6xl mx-auto px-6 pt-8 pb-2">
					<button
						type="button"
						onClick={() => setActiveIndex(0)}
						className="inline-flex items-center gap-2 text-sm font-medium text-slate-600 hover:text-emerald-600 transition-colors">
						<ArrowLeft size={16} weight="bold"/>
						Back to campaigns
					</button>
				</div>
			)}
			<div>
				{activeIndex === 0 ? (
					<NewCampaign onChildAction={setActiveIndex} setcurrentCampaign={setcurrentCampaign}/>
				) : (
					<EditCampaign currentCampaignFromParent={currentCampaign}/>
				)}
			</div>
		</div>
	);
};

export default CampaignHorizontalSubMenuComponent;
